import { IStore } from '../types/IStore';

export const contacts = (state: IStore) => state.utils?.contacts;
export const getLanguages = (state: IStore) => state.utils?.languages;
export const getEnableAiOnboarding = (state: IStore) =>
  state.utils?.enableAIOnboarding ?? false;
export const getIsAiOnboardingCallActive = (state: IStore) =>
  state.utils?.isAiOnboardingCallActive ?? false;
export const loadingSelector = (state: IStore) => state.utils.loading;
export const outPublicKey = (state: IStore) => state.utils?.publicKey;
export const userHash = (state: IStore) => state.utils?.userHash;
export const biometricEnabled = (state: IStore) => state.utils?.isBiometricEnabled;
export const tourCompleted = (state: IStore) => state.utils?.isTourCompleted;
export const shouldShowBiometric = (state: IStore) => state.utils?.showBiometric; 
export const getNearbyProps = (state:IStore) => state.utils.nearbyLocation;
export const getSelectedIds = (state:IStore) => state.utils.selectedIds;
export const getSelectionMode = (state: IStore) => state.utils.selectionMode;
export const istermsAgreedStatus = (state: IStore) => state.utils.termsAndConditions;
export const publicAvailableShifts = (state: IStore) => state.utils.publicAvailableShifts;
export const publicPharmacyRatingItems = (state: IStore) => state.utils.pharmacyRatingItems;
export const publicProfessionalRatingItems = (state: IStore) => state.utils.professionalRatingItems;
export const getLongTermContractAttributes = (state: IStore) => state.utils.longTermContractAttributes;
export const getBookedContractDates = (state: IStore) => state.utils.bookedContractDates;
export const getInitialLandingURL = (state: IStore) => state.utils.initialLandingURL;
export const getCertificateFileName = (state: IStore) => state.utils.certificateFileName;
export const getTechnicianDiploma = (state: IStore) => state.utils.technicianDiploma;
export const getProfessionalResume = (state: IStore) => state.utils.professionalResume;
export const getProfessionalImage = (state: IStore) => state.utils.professionalImage;
export const getCampaignImages = (state: IStore) => state.utils.campaignImages;
export const getCampaignTemplates = (state: IStore) => state.utils.campaignEmailTemplates;